import styled from 'styled-components';

import { useIsFeatureFlagEnabled } from '@paradigm/features/src/feature-flags/store';
import { UnifiedRfqTradeTapeProvider } from '@paradigm/features/src/unified-rfqs/contexts/unified-trade-tapes';

import {
  FEATURE_BLOCK_TERMINAL,
  useTerminalDrawerState,
} from '#/features/terminal/drawer-context';

import BlockTerminalTab from '#/components/Terminal/BlockTerminalTab';
import { LocalTabFiltersProvider } from '#/components/UnifiedRfqs/UnifiedRfqs';

/**
 * Right-rail mount of the Block Terminal. Renders only when the user has
 * pinned the terminal as a side panel and the drawer is open. Both the
 * bottom-panel tabs and the side panel are visible simultaneously, similar
 * to the Paradex layout.
 *
 * `UnifiedRfqProviders` is mounted once at the App level by
 * `ScopedUnifiedRfqProviders`, above both `<Routes />` and this panel.
 * That's the only way to share a single provider tree across two sibling
 * subtrees without duplicating `DrfqNotificationsService` and firing
 * every fill toast twice.
 */
export default function BlockTerminalSidePanel() {
  const enabled = useIsFeatureFlagEnabled(FEATURE_BLOCK_TERMINAL);
  const { isOpen, pinMode } = useTerminalDrawerState();

  if (!enabled) return null;
  if (pinMode !== 'side-panel') return null;
  if (!isOpen) return null;

  return (
    <Panel>
      <LocalTabFiltersProvider storageKey="trade-tape-rfq-tab-filters">
        <UnifiedRfqTradeTapeProvider>
          <BlockTerminalTab />
        </UnifiedRfqTradeTapeProvider>
      </LocalTabFiltersProvider>
    </Panel>
  );
}

const Panel = styled.aside`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 420px;
  max-width: 100vw;
  background: var(--bg-color-container, #0e131a);
  border-left: 1px solid var(--border-color, rgba(255, 255, 255, 0.08));
  display: flex;
  flex-direction: column;
  z-index: 900;
  box-shadow: -8px 0 24px rgba(0, 0, 0, 0.35);
`;
